import apiClient from '@/api/apiClient';
import { handleError, getAuthData, prepareModel } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    modelList: [],
    status: '',
  },

  getters: {
    schema: (state) => state.schema,
    modelList: (state) => state.modelList,
    status: (state) => state.status,
  },

  mutations: {
    SET_SCHEMA(state, schema) {
      state.schema = schema;
    },
    SET_RECORDS(state, { recordsData }) {
      state.modelList = typeof recordsData?.modelList === 'object' ? recordsData.modelList : {};
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
  },

  actions: {
    async fetchSchema({ commit }) {
      try {
        commit('SET_STATUS', 'loading');
        const res = await apiClient.caxAFFxClarificationsSchema();
        const schema = res.data;
        commit('SET_SCHEMA', schema);
      } catch (error) {
        handleError(error, commit);
      }
    },

    async fetchRecords({ commit, rootState }) {
      try {
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        const res = await apiClient.modelCAxAFFxClarifications(clinicalHistories_id, institutions_profes_id);
        const recordsData = res?.data?.data ?? {};
        commit('SET_RECORDS', { recordsData });
        commit('SET_STATUS', 'loaded');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async saveRecords({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'save');
        const preparedModel = prepareModel(rootState, model);
        await apiClient.saveCAxAFFxClarifications(preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },
  },
};
